var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',{attrs:{"text-xs-center":""}},[_c('h1',{staticClass:"display-2 secondary--text"},[_vm._v("Whoops, "+_vm._s(_vm.pageData.codice))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.pageData.message))])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/pages/404.vue?vue&type=template&id=7a20573b&scoped=true&
// module id = 940
// module chunks = 0